export default function courses() {
    $('.course-page__tabs-controls__tab').on('click', function(e) {
        
        e.preventDefault();
        var url = $(e.currentTarget).attr('href');
        // Change the url via javascript so the page can be shared to the right tab.
        history.pushState('', '', url);

        // Append the partial param to the url.
        // This tells the server that we only need the ajax content for this particular tab, and not a complete page.
        url += '?partial=true';

        // Replace the #tab-content div's content with a loading animation.
        $('#tab-content').html('<div class="loading-pp"><div class="loading-pp__loader"></div><div class="loading-pp__text"><p>Loading</p></div></div>');

        // Add an active state to the tab we just clicked, and remove that same state from any other tabs.
        $('.course-page__tabs-controls__tab.active').removeClass('active');
        $(e.currentTarget).addClass('active');

        fetchTabContent(url, function(data) {
            // Replace the tab-content div's content with the newly loaded content.
            $('#tab-content').html(data);
        });
        e.preventDefault();
    });
}

 /**
 * Method handles the ajax call to load content for the tabs.
 *
 *      @param url: String
 *      @param callback: function.
 */
function fetchTabContent(url, callback) {
    $.ajax({
        url: url,
        success: function(data) {
            callback(data);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            alert('Something went wrong while fetching the page');
        }
    });
};


// WEBPACK FOOTER //
// ./src/Resources/ui/js/courses.js